import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"border-radius":"6px","overflow":"hidden"}
}
const _hoisted_2 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_cropper = _resolveComponent("cropper")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "App-User-Profile-Modal",
    "model-value": _ctx.isModalOpen,
    width: "550px",
    "show-close": _ctx.showClose,
    onOpen: _ctx.opened,
    title: "Profile Picture",
    center: "",
    "close-on-click-modal": _ctx.showClose,
    "append-to-body": true,
    "lock-scroll": true,
    "open-delay": 200,
    "close-delay": 200,
    "before-close": _ctx.closeModal,
    "close-on-press-escape": false
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_space, {
          fill: "",
          "w-100": "",
          size: 12,
          direction: "vertical"
        }, {
          default: _withCtx(() => [
            (_ctx.avatar !== '')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  "is-block": "",
                  icon: "el-icon-refresh",
                  onClick: _ctx.handleRemove,
                  type: "default",
                  disabled: _ctx.loading,
                  plain: "",
                  "is-all-borderless": ""
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" Change Image ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "disabled"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              "is-block": "",
              icon: "el-icon-check",
              onClick: _ctx.submit,
              size: "large",
              type: "primary",
              disabled: _ctx.loading
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Save ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { "txt-center": "" }, [
          _createElementVNode("p", {
            "m-t-0": "",
            "m-rl-auto": "",
            style: {"max-width":"350px"}
          }, [
            _createTextVNode(" Upload a file by clicking or drag-and-drop "),
            _createElementVNode("br"),
            _createElementVNode("b", null, " Max Size: 3MB (Megabytes) ")
          ])
        ], -1)),
        _createVNode(_component_el_form, {
          onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
          class: "App-Styled-Form",
          "label-position": 'top',
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _withDirectives(_createVNode(_component_el_upload, {
                ref: "upload",
                "m-rl-auto": "",
                "txt-center": "",
                "list-type": "picture-card",
                "auto-upload": false,
                "on-remove": _ctx.handleRemove,
                "on-change": _ctx.handleAdd,
                multiple: false,
                drag: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { "f-w-800": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Plus)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["on-remove", "on-change"]), [
                [_vShow, _ctx.avatar === '']
              ]),
              (_ctx.avatar !== '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_cropper, {
                      class: "cropper",
                      src: _ctx.avatar,
                      "stencil-props": {
                aspectRatio: 1 / 1,
              },
                      onReady: _ctx.finishedLoadingCropper,
                      ref: "cropper"
                    }, null, 8, ["src", "onReady"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "show-close", "onOpen", "close-on-click-modal", "before-close"]))
}